module.exports = __webpack_public_path__ + "img/icon-6.e741216d.svg";